import { Checkmark } from "@carbon/icons-react";
import { useTranslation } from "react-i18next";

import { IStep } from "../../../models/step";

interface StepItemProps {
  step: IStep;
  isSelected: boolean;
  menuItemClass: string;
  clickItem: (step: IStep) => void;
}

const StepItem = (props: StepItemProps) => {
  const { t } = useTranslation();
  const { step, isSelected, menuItemClass, clickItem } = props;

  return (
    <div
      className={menuItemClass}
      onClick={() => clickItem(step)}
      data-testid={
        step.done && !isSelected ? "progress-bar-popup-item-done" : ""
      }
    >
      <div className="progress-bar-popup-item-icon">
        {step.done && !isSelected ? (
          <div data-testid="progress-bar-popup-item-done">
            <Checkmark size={24} />
          </div>
        ) : (
          step.icon
        )}
      </div>
      <div className="progress-bar-popup-item-text">
        {`0${step.number} - ${t(step.text)}`}
      </div>
    </div>
  );
};
export default StepItem;
